export const ROLE_DIRECTOR = "director"
export const ROLE_EMPLOYEE = "employee"
export const ROLE_ADMIN = "superadmin"
